import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Mail, MapPin, Phone } from "lucide-react";
import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { LeadForm } from "../components/forms/LeadForm";
import { useLang } from "../i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const validInterests = ["distribution", "private-label", "product-sourcing", "market-development", "general-partnership", "product", "technical"];

export default function ContactPage() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [settings, setSettings] = useState(null);
  const interestParam = params.get("interest");
  const defaultInterest = validInterests.includes(interestParam) ? interestParam : "";

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setSettings(r.data)).catch(() => setSettings(null));
  }, []);

  const hasInfo = settings && (settings.email || settings.phone || settings.address);

  return (
    <>
      <SEO page="contact" />
      <PageHero eyebrow={t.contact.eyebrow} title={t.contact.title} sub={t.contact.sub} testId="contact-hero" />

      <section className="bg-[#F7F8F5] py-20 md:py-28">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-8">
            <div className="bg-white border border-black/8 p-8 md:p-12">
              <LeadForm variant="contact" defaultInterest={defaultInterest} />
            </div>
          </Reveal>
          {hasInfo && (
            <Reveal delay={0.15} className="lg:col-span-4">
              <div className="space-y-5 text-sm text-slate-700" data-testid="contact-info-panel">
                {settings.email && <p className="flex items-center gap-3"><Mail size={16} className="text-[#19C7C1]" />{settings.email}</p>}
                {settings.phone && <p className="flex items-center gap-3"><Phone size={16} className="text-[#19C7C1]" />{settings.phone}</p>}
                {settings.address && <p className="flex items-center gap-3"><MapPin size={16} className="text-[#19C7C1]" />{settings.address}</p>}
              </div>
            </Reveal>
          )}
        </div>
      </section>
    </>
  );
}
